module.exports = __webpack_public_path__ + "img/27.69bf6969.png";